import request from "../base-request";

export const getPageState = async (pageName: string) => {
	const [data] = await request<any>(`/api/page-state/${pageName}/`);
	return data?.state || {};
};

export const updatePageState = async <Type>(pageName: string, pageState: Type, merge = false) => {
	const [data] = await request<any>(`/api/page-state/${pageName}/`, {
		method: "PATCH",
		body: JSON.stringify({ pageState, merge }),
	});
	return data?.state || {};
};
